export const GASTOS_CONTENT = {
    lessons: {
        // gastos.egresos — «Cargar un egreso» — roles: receptionist (Recepcionista), branch_manager (Encargado de sede), admin (Administración), owner (Dueño), accountant_readonly (Contador, sólo lectura) — pantalla: "contable.egresos" — práctica: sí
        "gastos.egresos": {
            summary: "Cómo se carga un gasto del club para que quede atado a una sede, una categoría, un comprobante y a quien lo cargó, y qué recorrido hace hasta quedar aprobado. Por qué la marca «sin comprobante» es una excepción con motivo, qué pasa con la mercadería del kiosko y por qué un gasto pagado con la plata de la caja se carga desde la caja del turno.",
            keyPoints: [
                "Todo egreso lleva sede (la tuya, o Central si es un gasto general del club), categoría, monto, medio de pago, fecha y el comprobante adjunto (foto o PDF); el proveedor es opcional. Recepción y encargados cargan los de su sede.",
                "Nace «pendiente» y lo aprueban o rechazan los dueños o Administración; el rechazo lleva motivo. Ningún egreso se aprueba solo.",
                "«Sin comprobante» es una excepción para cuando el comprobante de verdad no existe: pide un motivo obligatorio, queda en la auditoría con tu usuario y sale resaltado en el libro de gastos del contador. Si falló la subida, se reintenta: no se marca sin comprobante.",
                "Mientras está pendiente, quien lo cargó todavía puede corregir la sede. Aprobado ya no se edita ni se borra: se anula con motivo y se vuelve a cargar bien.",
                "Un gasto pagado con el efectivo de la caja se carga desde la Caja del turno, como gasto menor.",
                "Una compra de mercadería del kiosko suma stock a la sede recién cuando se aprueba; si después se anula, el stock vuelve con un ajuste. El contador consulta los egresos.",
            ],
            estimatedMin: 7,
            contentVersion: 2,
        },
        // gastos.proveedores — «Proveedores» — roles: admin (Administración), owner (Dueño), accountant_readonly (Contador, sólo lectura) — pantalla: "contable.proveedores" — práctica: no
        "gastos.proveedores": {
            summary: "Para qué sirve el padrón de proveedores y cómo se mantiene: datos fiscales, rubro y modalidad (mensual fija o por reposición de stock). Cómo leer el gasto acumulado y la última compra, que salen de los egresos aprobados, y cómo iniciar una compra de mercadería desde el proveedor.",
            keyPoints: [
                "Cada proveedor tiene razón social, CUIT (once dígitos sin guiones, que el sistema valida), condición frente al IVA, rubro, contacto y modalidad: mensual fija o por reposición de stock.",
                "Usá siempre la misma palabra de rubro para proveedores parecidos, así el filtro por rubro sirve.",
                "El gasto acumulado, la última compra y el historial salen de los egresos aprobados: un egreso pendiente todavía no es gasto.",
                "Una última compra vacía quiere decir «nunca se le cargó un egreso aprobado», que no es lo mismo que una compra de $ 0.",
                "Nada se borra: si ya no trabaja con el club, se desactiva. Deja de aparecer al cargar egresos y su historial queda.",
                "El alta, la edición y «Iniciar una compra de mercadería» son de Administración o un dueño; el contador consulta y ni siquiera ve esos botones.",
            ],
            estimatedMin: 4,
            contentVersion: 2,
        },
    },
    questions: [
        // ── gastos.egresos ──────────────────────────────────────────────────────
        {
            id: "gastos.egresos#1",
            lessonKey: "gastos.egresos",
            prompt: "Vas a subir la foto del ticket de un arreglo y la subida falla dos veces. ¿Qué hacés?",
            options: [
                { id: "a", text: "Activo «Sin comprobante» y explico en el motivo que no subía la foto." },
                { id: "b", text: "Cargo el egreso sin adjuntar nada y aviso por mensaje a Administración." },
                {
                    id: "c",
                    text: "Reintento o saco otra foto más liviana: el ticket existe.",
                },
                { id: "d", text: "Lo cargo desde la Caja del turno, que no pide comprobante." },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, si el comprobante no se sube probás de nuevo o con una foto más liviana. La marca «sin comprobante» es para cuando el comprobante de verdad no existe, no para cuando falla la subida.",
        },
        {
            id: "gastos.egresos#2",
            lessonKey: "gastos.egresos",
            prompt: "Un egreso de mantenimiento ya fue aprobado y después te das cuenta de que tenía mal el monto. ¿Cómo se corrige?",
            options: [
                { id: "a", text: "Lo editás y cambiás el monto: queda registrado quién lo modificó." },
                {
                    id: "b",
                    text: "Se anula con motivo y se vuelve a cargar bien.",
                },
                { id: "c", text: "Se borra y se carga uno nuevo, así no quedan dos en el libro." },
                { id: "d", text: "Se rechaza y vuelve a pendiente para que quien lo cargó lo corrija." },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, mientras está pendiente todavía se puede corregir, pero una vez aprobado ya no se edita: si estaba mal, se anula con motivo y se vuelve a cargar bien. Nada se borra.",
        },
        {
            id: "gastos.egresos#3",
            lessonKey: "gastos.egresos",
            prompt: "Compraste gaseosas para el kiosko y cargaste el egreso como compra de mercadería, con cada producto y su costo. ¿Cuándo aparece ese stock en la sede?",
            options: [
                { id: "a", text: "Apenas tocás Cargar, aunque el egreso esté pendiente." },
                { id: "b", text: "Nunca solo: después hay que cargarlo a mano en el stock del kiosko, producto por producto." },
                { id: "c", text: "Cuando el contador revisa el libro de gastos del mes." },
                { id: "d", text: "Cuando un dueño o Administración aprueba el egreso: ahí se suma solo." },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, al detallar la mercadería con Agregar línea, el stock se suma a la sede solo cuando el egreso se aprueba. Y si un aprobado se anula, ese stock vuelve con un ajuste.",
        },
        {
            id: "gastos.egresos#4",
            lessonKey: "gastos.egresos",
            prompt: "En recepción le pagás al plomero con el efectivo de la caja. ¿Dónde se carga ese gasto?",
            options: [
                { id: "a", text: "Desde la Caja del turno, como gasto menor." },
                { id: "b", text: "En Administración → Gastos → Egresos, con sede Central." },
                { id: "c", text: "No se carga: lo registra Administración cuando cierra el mes." },
                { id: "d", text: "En Egresos, marcado «sin comprobante» porque es efectivo." },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, si el gasto se paga con el efectivo de la caja, se carga desde la Caja del turno como gasto menor, así la plata que salió de la caja queda explicada.",
        },
        // ── gastos.proveedores ──────────────────────────────────────────────────
        {
            id: "gastos.proveedores#1",
            lessonKey: "gastos.proveedores",
            prompt: "La empresa de limpieza dejó de trabajar con el club. ¿Qué hacés con ese proveedor en el padrón?",
            options: [
                { id: "a", text: "Lo borrás, así no aparece más en ninguna lista." },
                { id: "b", text: "Lo desactivás: deja de aparecer al cargar egresos y su historial queda." },
                { id: "c", text: "Le cambiás la razón social por «NO USAR» para que nadie lo elija al cargar egresos." },
                { id: "d", text: "Lo dejás como está: los proveedores no se pueden tocar." },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, un proveedor no se borra: si ya no trabaja con el club se desactiva, deja de aparecer al cargar egresos y su historial se conserva.",
        },
        {
            id: "gastos.proveedores#2",
            lessonKey: "gastos.proveedores",
            prompt: "Al dar de alta un proveedor, el sistema no acepta el CUIT. ¿Qué es lo más probable y qué hacés?",
            options: [
                { id: "a", text: "El proveedor no está inscripto: no se lo puede cargar." },
                { id: "b", text: "Falta poner los guiones: lo escribís con el formato 30-xxxxxxxx-x." },
                {
                    id: "c",
                    text: "Un dígito cambiado: lo revisás contra la factura.",
                },
                { id: "d", text: "Lo guardás sin CUIT y lo completás más adelante." },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, el CUIT va con sus once dígitos sin guiones y el sistema lo valida. Si no pasa, casi siempre es un dígito cambiado: se revisa contra la factura.",
        },
        {
            id: "gastos.proveedores#3",
            lessonKey: "gastos.proveedores",
            prompt: "A un proveedor se le cargó un egreso ayer que todavía está pendiente. ¿Suma a su gasto acumulado?",
            options: [
                { id: "a", text: "Sí, cuenta desde el momento en que se carga." },
                { id: "b", text: "Sí, pero marcado en otro color hasta que Administración lo apruebe." },
                { id: "c", text: "Sólo si tiene el comprobante adjunto." },
                { id: "d", text: "No: el gasto acumulado cuenta sólo los egresos aprobados." },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, el gasto acumulado cuenta sólo los egresos aprobados: uno pendiente todavía no es gasto.",
        },
        {
            id: "gastos.proveedores#4",
            lessonKey: "gastos.proveedores",
            prompt: "Abrís la ficha de un proveedor y la última compra aparece vacía. ¿Qué significa?",
            options: [
                { id: "a", text: "Que nunca se le cargó un egreso aprobado, no que se le compró por $ 0." },
                { id: "b", text: "Que la última compra fue de $ 0." },
                { id: "c", text: "Que el proveedor está desactivado." },
                { id: "d", text: "Que el contador no tiene permiso para ver ese dato en la ficha del proveedor." },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, si un proveedor no muestra última compra es que nunca se le cargó un egreso aprobado, no que se le compró por cero pesos.",
        },
    ],
};
//# sourceMappingURL=gastos.js.map